import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Typography, Box } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import AppHeader from '../components/common/AppHeader'
import MaskTool from '../components/photoTools/MaskTool'

const PhotoMaskPage: React.FC = () => {
  const navigate = useNavigate()
  const { user, logout, isAdmin } = useAuth()

  const handleBackClick = () => {
    navigate('/photo-tools')
  }

  return (
    <>
      <AppHeader
        title="Maska"
        username={user?.username}
        showAdminButton={isAdmin}
        showBackButton
        onBackClick={handleBackClick}
        onLogout={logout}
      />

      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Maska
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Segmentacja ciała i generowanie maski (BodyPix lub SAM3)
          </Typography>
        </Box>

        <MaskTool />
      </Container>
    </>
  )
}

export default PhotoMaskPage

